import React from 'react';
import './OQueVoceAprendera.css';
import ToggleList from './ListaToggle';
function OQueVoceAprendera({ onScroll }) {

    const pesquisaItems = [
      'Como iniciar sua pesquisa',
      'Quais informações preciso saber para iniciar?',
      'Quais os principais tipos de trabalhos acadêmicos?',
      'Quais as principais bases de dados científicos?',
      'Quais as principais funções da pesquisa científica?',
      'Como escolho minha área de pesquisa?',
      'Quais são as etapas do processo de pesquisa?'
    ];

    const aspectosItems = [
      'Aspectos práticos da pesquisa científica!',
      'Este livro serve para quais tipos de trabalho?',
      'Este livro serve para quais sistemas de chamada?',
      'Qual a origem do trabalho científico analisado?'
    ];

    const estruturaItems = [
      'Como é a estrutura básica de um trabalho científico',
      'Introdução',
      'Desenvolvimento (dividido em seções)',
      'Considerações finais/conclusão',
      'Referências'
    ];

    const metodoItems = [
      'Como escolher o método da pesquisa?',
      'O que preciso saber sobre metodologia científica?',
      'Qual o método da minha pesquisa?'
    ];

    const outrosItems = [
      'Como encontro outros trabalhos?',
      'O que preciso saber antes das buscas (levantamento bibliográfico)?',
      'Como são as principais plataformas científicas?'
    ];

    const maisItems = [
      'Muito mais? (em breve)',
      'Como faço uma pesquisa bibliográfica?',
      'Como faço uma revisão de literatura?',
      'Como faço uma pesquisa empírica?',
      'Como faço uma pesquisa quantitativa?',
      'Como posso usar o Word para formatar meu trabalho?',
      'Quais são as principais regras da ABNT?',
      'Como posso escrever melhor e mais rápido',
      'Quais são as técnicas e regras linguísticas mais utilizadas na pesquisa científica',
      'Como usar ferramentas de inteligência artificial na pesquisa científica?',
      'Como conferir plágio no meu trabalho e não reprovar por isso?',
      'Muito mais, mas muito, muito, muito mais mesmo, sério.'
    ];
  return (
    <div className='aprendera-container'>
      <h2>Do início ao fim – confira o que você aprenderá com o livro "Pesquisa Científica: Aspectos Práticos"</h2>
      <div className='purple-shape'>é praticamente alguém do seu lado mostrando como fazer </div>
      <div className='aprendera-toggle-container'>
        <div>
          <ToggleList title="Como iniciar sua pesquisa" items={pesquisaItems} />
          <ToggleList title="Aspectos práticos da pesquisa científica!" items={aspectosItems} />
          <ToggleList title="Como é a estrutura básica de um trabalho científico" items={estruturaItems} />
        </div>
        <div>
          <ToggleList title="Como escolher o método da pesquisa?" items={metodoItems} />
          <ToggleList title="Como encontro outros trabalhos?" items={outrosItems} />
          <ToggleList title="Muito mais?" items={maisItems} />
        </div>
      </div>
      <button onClick={onScroll} className='main-btn alt'>Isso é tudo que eu preciso!</button>
    </div>
  );
}

export default OQueVoceAprendera;
